// @flow

import styled from 'styled-components';
import Link from '../../../link';
import type { Theme } from '../../../../types';

export default styled<typeof Link, Theme>(Link)`
  color: ${props => props.theme.pdbInfo.occasionText.color};
  font-size: ${props => props.theme.pdbInfo.occasionText.fontSize};

  &::after {
    border-style: solid;
    border-width: 0 0 1px 1px;
    content: '';
    display: inline-block;
    height: .25rem;
    width: .25rem;
    transform: rotateZ(225deg) translate(-2px, 4px);
  }
`;
